<div :class="['loader-ui', { 'fullscreen': fullscreen, 'container-overlay': overlay }]">
  <div class="spinner-border loader-ui__spinner" role="status"></div>
</div>
